export default __webpack_public_path__ + "static/media/pune.78cec1f5.webp";